import { styled } from "theme/default/styled";

export const SCustomSelectContainer = styled.div`
  width: 100%;
`;
